import React, { useEffect, useRef, useState } from "react";

import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignLanguage,
  faPen,
  faEraser,
} from "@fortawesome/free-solid-svg-icons";
import { modulo4 } from "../../../routes/Module4";
import { ReactSketchCanvas } from "react-sketch-canvas";

import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo4/Actividad 8.mp3";

const styles = {
  border: "1px solid #9c9c9c",
  borderRadius: "0",
  height: "480px",
};

const Actividad8 = () => {
  const [eraseMode, setEraseMode] = useState(false);
  const [penMode, setPenMode] = useState(true);
  const infoUnidad = modulo4.content[0];
  const infoAct = modulo4.content[0].activities[7];
  const crumbs = [
    {
      title: modulo4.title,
      url: "/" + modulo4.url,
    },
    {
      title:
        modulo4.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `Cierre`,
    linkNext: `${modulo4.url}/cierre`,
    titlePrev: `${modulo4.content[0].activities[6].name}`,
    linkPrev: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo4.color,
    title: `${modulo4.title} - ${infoAct.name}`,
    name: modulo4.title,
  };

  const canvasEl = useRef(null);
  const activateEraser = () => {
    setEraseMode(!eraseMode);
    setPenMode(eraseMode);
  };
  const activatePen = () => {
    setPenMode(!penMode);
    setEraseMode(penMode);
  };
  useEffect(() => {
    if (eraseMode) {
      canvasEl.current.eraseMode(true);
    } else {
      canvasEl.current.eraseMode(false);
    }
  }, [eraseMode]);
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo4.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">Actividad 8</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          Para terminar, debemos recordar que el Perú es uno de los países más
          diversos del mundo. Tiene muchos territorios y climas distintos. Viven
          en él muchas especies de plantas y animales. Se hablan decenas de
          lenguas y hay costumbres muy variadas.
        </li>
        <li>
          Con la ayuda de algunos compañeros o compañeras o de un familiar,
          hagan un cartel que celebre la diversidad de nuestro país.
        </li>
        <li>
          En este espacio pueden hacer un modelo del cartel y luego lo pasarán a
          un papelote.
        </li>
      </ul>

      <ReactSketchCanvas
        ref={canvasEl}
        style={styles}
        width="600"
        height="100%"
        strokeWidth={4}
        strokeColor="red"
      />
      <div className="d-flex mt-1 justify-content-end w-100">
        <button
          onClick={activateEraser}
          className={`btn btn-green me-1 ${eraseMode ? "active" : "inactive"}`}
        >
          Borrador <FontAwesomeIcon icon={faEraser} />
        </button>
        <button
          onClick={activatePen}
          className={`btn btn-green me-1 ${penMode ? "active" : "inactive"}`}
        >
          Lapiz <FontAwesomeIcon icon={faPen} />
        </button>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Explique lo que se debe hacer. Conversen sobre
          qué incluir en los carteles. Acompañe el proceso. Sugiera colgar los
          papelotes en el aula o en algún espacio del hogar.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
